import { Divider, Grid, GridItem, Spacer} from "@chakra-ui/react";
import { NavLink, Outlet } from "react-router-dom";

import { ReactComponent as Wave } from "../Assets/Footer.svg";

import SidebarPagesList from "../Components/SidebarPagesList";
import HeaderComponent from "../Components/HeaderComponent";
import CreditsModal from "../Components/CreditsModal";

export default function RootLayout(){
    return (
        <Grid templateColumns="repeat(6, 1fr)" templateRows="repeat(5,1fr)" bg="gray.50" >
            <GridItem
            as="nav"
            bg="purple.400"
            gridArea="1/1/7/1"
            h="100vh"
            p="10px"
            textAlign="center"
            >
                <CreditsModal/>
                <Spacer h="0px"/>
                <Wave/>
                <Divider color="black.600"/>
                <Spacer h="10px"/>
                <SidebarPagesList/>
                <Spacer h="20px"/>            
                <NavLink to={"About"}>About</NavLink>               
            </GridItem>

            <GridItem
            as="header"
            bg=""
            gridArea="1/2/2/7"
            textAlign="center"
            p="10px"
            fontSize="6xl"
            >
                <HeaderComponent/>
            </GridItem>

            <GridItem 
            as="footer"
            gridArea="6/1/6/7"
            >
                <Wave/>
            </GridItem>

            <GridItem
            as="main"
            bg="pink.300"
            gridArea="2/2/6/7"
            textAlign="center"
            alignItems="center"
            justifyItems="center"
            // p="50px"
            p="10vh"
            >
                <Outlet/>
            </GridItem>
        </Grid>
    )
}